import React from 'react';

function Footer() {
  return (
    <footer className="footer">
      <p>🏔️ Timber Summit Expo &copy; 2026 — The Premium Woodworking Expo</p>
      <p className="footer-tech">Powered by AWS • Secured with JWT • Payments via Stripe Connect</p>
      <p className="footer-links">
        <a href="/terms-of-service.md" target="_blank">Terms of Service</a> • <a href="/terms-of-use.md" target="_blank">Terms of Use</a> • <a href="/privacy-policy.md" target="_blank">Privacy Policy</a>
      </p>
    </footer>
  );
}

export default Footer;
